module.exports = __webpack_public_path__ + "static/media/1007001.2d745385.jpg";